import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

const PAY_OPS_ROLES = [
  Roles.pay_operations_viewer,
  Roles.pay_operations_agent,
  Roles.pay_operations_admin,
];

const PAY_OPS_ADMIN_ROLES = [Roles.pay_operations_admin];

const RECEIPT_UPLOAD_ROLES = [
  Roles.customer_support_agent,
  Roles.customer_support_admin,
  Roles.pay_operations_agent,
  Roles.pay_operations_admin,
];

export const payOperationsSection: MenuItem[] = [
  {
    headTitle1: 'ryd Pay Operations',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [...new Set([...PAY_OPS_ROLES, ...RECEIPT_UPLOAD_ROLES])],
  },
  {
    path: '/pay-operations/overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    title: 'Overview',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: PAY_OPS_ROLES,
  },
  {
    title: 'Order Amendments',
    icon: 'stroke-ecommerce',
    iconf: 'fill-ecommerce',
    type: 'sub',
    active: false,
    activePathPrefixes: ['/pay-operations/order-amendments'],
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: PAY_OPS_ROLES,
    children: [
      {
        path: '/pay-operations/order-amendments/guide',
        title: 'Guide',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: PAY_OPS_ROLES,
      },
      {
        path: '/pay-operations/order-amendments/queue',
        title: 'Queue',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: PAY_OPS_ROLES,
      },
      {
        path: '/pay-operations/order-amendments/manual-assignment',
        title: 'Manual Assignment',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.pay_operations_agent, Roles.pay_operations_admin],
      },
      {
        path: '/pay-operations/order-amendments/odoo-payment-update',
        title: 'Odoo Payment Update',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.pay_operations_agent, Roles.pay_operations_admin],
      },
      {
        path: '/pay-operations/order-amendments/incidents',
        title: 'Incidents',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: PAY_OPS_ROLES,
      },
      {
        path: '/pay-operations/order-amendments/audit',
        title: 'Audit',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: PAY_OPS_ADMIN_ROLES,
      },
    ],
  },
  {
    path: '/pay-operations/receipt-upload',
    icon: 'stroke-file',
    iconf: 'fill-file',
    title: 'Receipt Upload',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: RECEIPT_UPLOAD_ROLES,
  },
];
